/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
// eslint-disable-next-line jira/import-whitelist
import { fireErrorAnalytics } from '@jira/platform__error-reporting/src/fireErrorAnalytics.tsx';
import {
	createResource,
	type RouterDataContext,
	type ResourceStoreContext,
	type RouteResource,
} from '@atlassian/react-resource-router';

import { performGetRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';
import type {
	ChangeCalendarFilterSettingsResource,
	ChangeCalendarFilterSettingsResponse,
} from './ChangeCalendarFilterSettingsResponse.types.tsx';

const getData = async (
	routerContext: RouterDataContext,
	{ tenantContext }: ResourceStoreContext,
): Promise<ChangeCalendarFilterSettingsResponse> => {
	if (!routerContext.match.params.projectKey) {
		return;
	}
	const { cloudId } = tenantContext;

	if (!routerContext.query.filterId) {
		return;
	}

	const { filterId } = routerContext.query;

	try {
		const response: ChangeCalendarFilterSettingsResponse = await performGetRequest(
			`/gateway/api/jsm/calendar/cloudid/${cloudId}/v1/change-calendar/filters/${filterId}`,
		);

		return response;
		// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	} catch (error: any) {
		fireErrorAnalytics({
			meta: {
				id: 'getChangeCalendarFilterSettings',
				packageName: 'jiraRouterResourcesJsmChangeCalendar',
				teamName: 'jenga',
			},
			error,
		});

		throw error;
	}
};

export const changeCalendarFilterSettingsResource: RouteResource<ChangeCalendarFilterSettingsResponse> =
	createResource<ChangeCalendarFilterSettingsResource>({
		getData,
		isBrowserOnly: true,
		type: 'CHANGE_CALENDAR_FILTER_SETTINGS_RESOURCE',
		maxAge: __SERVER__ ? 0 : Number.MAX_SAFE_INTEGER,
		getKey: ({ query }) => `CHANGE_CALENDAR_FILTER_SETTINGS_RESOURCE-${query.filterId}`,
	});
